import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "is-size-5-mobile is-size-4-tablet medium-text" }
const _hoisted_2 = { class: "is-size-5-mobile is-size-4-tablet medium-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("span", _hoisted_1, _toDisplayString(`${_ctx.plan.leads_amount} Verified Jobs`), 1),
    _cache[1] || (_cache[1] = _createElementVNode("span", { class: "is-size-6-mobile is-size-5-tablet" }, [
      _createElementVNode("br"),
      _createTextVNode("for"),
      _createElementVNode("br")
    ], -1)),
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.priceFormatter(_ctx.plan.price)), 1),
    _createElementVNode("span", null, [
      _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
      _createTextVNode("(" + _toDisplayString(_ctx.priceFormatter(_ctx.plan.price_per_lead)) + "/lead)", 1)
    ])
  ]))
}